module.exports = __webpack_public_path__ + "img/757ccf5.jpg";